import { useState } from "react";
import Header from "../../components/Header.js";
import BackButton from "../../components/BackButton.js";
import Upload, { type UploadFile } from "../../components/Upload";
import Button from "../../components/Button.js";
import SelectedFilesPreview from "./SelectedFilesPreview"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import BulkUploadService from "../../services/bulk-upload.service.js";
import { toast, type ToastOptions } from "react-toastify";

function useImportBoundaryDataPage() {

  const [boundaryFile, setBoundaryFile] = useState<UploadFile[]>([]);

  function removeBoundaryFile(fileName: string) {
    const maybeFile = boundaryFile.find(f => f.file.name === fileName);
    if (maybeFile === undefined) {
      return;
    }

    URL.revokeObjectURL(maybeFile.previewUrl);
    setBoundaryFile(files => files.filter(f => f.file.name !== fileName));
  }

  function boundaryTemplate() {
    BulkUploadService.boundaryTemplate()
      .then((response) => {
        const url = response.data.s3url;
        const link = document.createElement("a");
        const filename = response.data.filename;
        link.href = url;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.log(error));
  };

  const notificationSettings: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  function uploadBoundaryData() {
    const uploadFile = boundaryFile[0];
    if (uploadFile === undefined) {
      return;
    }

    BulkUploadService.uploadBoundaryData({ file: uploadFile.file })
      .then((response) => {
        console.log(response);
        toast.success(`The system is uploading your file for processing. Please check your email shortly for more information.`, notificationSettings);

        removeBoundaryFile(uploadFile.file.name);
      })
      .catch((error) => {
        const maybeMessage = error?.response?.data?.apierror?.message;
        if (maybeMessage !== undefined) {
          toast.error(maybeMessage, notificationSettings);
        } else {
          toast.error(`The system was unable to process your file.`, notificationSettings);
        }
      });
  }

  return { boundaryFile, setBoundaryFile, uploadBoundaryData, removeBoundaryFile, boundaryTemplate };
}

interface ImportBoundaryDataPageProps {
  setPage: unknown;
}

function ImportBoundaryDataPage(props: ImportBoundaryDataPageProps) {
  const { boundaryFile, setBoundaryFile, uploadBoundaryData, removeBoundaryFile, boundaryTemplate } = useImportBoundaryDataPage();

  return (
    <div className="page" id="boundaryDataPage">
      <Header title="Boundary Data Page" />
      <BackButton
        setPage={props.setPage}
        target={["adminDashPage", "backward"]}
      />

      <h3>ELR Boundary Update</h3>

      <p style={{ fontWeight: "bold" }}>
        By using this service you will update the Subzone Boundary, which may have an effect on the ELR Boundary as the system will calculate the lowest and maximum values for that ELR.
      </p>

      <div className="bulk-upload">
        <Button
          action="secondary"
          label="Download Boundary Template for Updating Route/ELR/MDUs"
          onClick={boundaryTemplate}
        >
          <FontAwesomeIcon icon={faDownload} className="button__icon" />
        </Button>
        {boundaryFile.length > 0 ? (
          <Button action="primary" label="Confirm and upload Boundary Data" onClick={uploadBoundaryData} />
        ) : (
          <Upload
            name="uploadBoundary"
            label="Bulk Upload Boundary Data"
            setFiles={setBoundaryFile}
            files={boundaryFile}
            disabled={false}
            camera={false}
            documents={[]}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        )}

        <SelectedFilesPreview uploadFiles={boundaryFile} removeFileWithName={removeBoundaryFile} />
      </div>
    </div>
  );
}

export default ImportBoundaryDataPage;
